module.exports = ".virtual-checkbox {\n  font-size: 36px;\n  border: solid 1px #999;\n  border-radius: 5px;\n  color: #fff; }\n  .virtual-checkbox.fa-check-square {\n    color: #333; }\n  .virtual-checkbox.fa-check-square:before {\n      content: \"\\f14a\" !important; }\n  .pointer {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/docs/docs.component.scss
// module id = ./src/app/docs/docs.component.scss
// module chunks = main